import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'chat',
  version: '0.1.0',
  kind: 'business',
  coreVersion: '^0.1.0',
  name: { vi: 'Chat', en: 'Chat' },
  description: {
    vi: 'Nhóm chat, tin nhắn riêng, nhắc tên, đính kèm file; tin hiện tức thì.',
    en: 'Group chats, direct messages, mentions, attachments; messages arrive instantly.',
  },
  dependsOn: [
    'core-system',
    'core-audit',
    'core-identity',
    'core-access',
    'core-files',
    'core-notification',
  ],
  database: { schema: 'chat' },
  permissions: [
    {
      key: 'chat.chat.use',
      name: { vi: 'Dùng chat', en: 'Use chat' },
      defaultGranted: true,
    },
  ],
  navigation: [
    {
      id: 'chat',
      label: { vi: 'Chat', en: 'Chat' },
      icon: 'message-square',
      path: '/chat',
      permission: 'chat.chat.use',
      order: 44,
    },
  ],
  notifications: [
    {
      key: 'chat.message',
      name: { vi: 'Tin nhắn riêng, được nhắc tên', en: 'Direct messages and mentions' },
      defaultChannels: ['in_app'],
    },
    {
      key: 'chat.unread',
      name: { vi: 'Email khi tin riêng / nhắc tên chưa đọc', en: 'E-mail for unread messages' },
      description: { vi: 'Sau 30 phút chưa đọc.' },
      defaultChannels: ['email'],
    },
  ],
});
